<template>
  <v-card outlined>
    <v-card-title>
      Ordering
      <v-spacer></v-spacer>
      <text-input v-model="search" label="Search" append-icon="search" hide-details />
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        no-data-text="No Manual Ordering Found"
        sort-by="country"
      >
        <template #item.position="{ item }">
          {{ positionForItem(item, 'position') }}
        </template>

        <template #item.paidPosition="{ item }">
          {{ positionForItem(item, 'paidPosition') }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import TextInput from '@/components/forms/text-input'

export default {
  name: 'OfferOrderTable',
  components: {
    TextInput,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: 'Country', value: 'country' },
      { text: 'Organic', value: 'position', align: 'end' },
      { text: 'Performance', value: 'paidPosition', align: 'end' },
    ],
    search: '',
  }),
  computed: {
    ...mapGetters('options', ['formattedOption']),
    items() {
      return Object.entries(this.offer).reduce((items, [geo, { paidPosition, position }]) => {
        if ([position, paidPosition].every(pos => pos == undefined)) return items
        items.push({
          country: this.formattedOption('countries', geo),
          paidPosition,
          position,
        })
        return items
      }, [])
    },
  },
  methods: {
    positionForItem(item, key) {
      if (item[key] == undefined) return '-'
      return item[key] + 1
    },
  },
}
</script>
